require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 75
// module chunks = 0 1